export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  categories: string[];
  description: string;
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  totalChapters: number;
  latestChapter: string;
  updatedAt: string;
  isHot: boolean;
  isRecommended: boolean;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line', count: 120 },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 35 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 28 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 22 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 18 },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line', count: 15 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 20 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 25 },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', count: 12 },
  { slug: 'school', name: '校园', icon: 'ri-building-line', count: 16 },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line', count: 14 },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20princess%20in%20elegant%20dress%20with%20long%20flowing%20hair%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20fantasy%20royal%20palace%20background%2C%20manga%20art%20style%2C%20detailed%20character%20design%2C%20clean%20centered%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    categories: ['romance', 'fantasy', 'drama'],
    description: '某天醒来，我发现自己成了小说中的公主。为了不被父亲杀死，我决定用尽一切方法活下去。这是一部关于爱与成长的奇幻浪漫故事，带你走进一个充满魔法与温情的世界。',
    rating: 9.5,
    views: 1280000,
    status: '连载中',
    totalChapters: 125,
    latestChapter: '第125话',
    updatedAt: '2026-08-05',
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-2',
    title: '我独自升级',
    author: 'Chugong / Dubu',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%20of%20a%20powerful%20hunter%20with%20dark%20aura%20and%20glowing%20eyes%2C%20dramatic%20lighting%2C%20dark%20fantasy%20style%2C%20epic%20composition%2C%20purple%20and%20black%20color%20scheme%2C%20intense%20atmosphere%2C%20detailed%20character%20illustration&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    categories: ['action', 'fantasy', 'thriller'],
    description: '十年前，世界各地出现了连接异次元的"门"，而人类中也出现了觉醒的"猎人"。等级最低的E级猎人成振宇，在一次双重地下城事件后，获得了只有他能看到的"系统"，从此他的命运开始改变。',
    rating: 9.8,
    views: 3560000,
    status: '已完结',
    totalChapters: 179,
    latestChapter: '第179话（完）',
    updatedAt: '2026-06-20',
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-3',
    title: '她的私生活',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20illustration%20of%20a%20beautiful%20office%20woman%20and%20handsome%20man%20close%20together%2C%20warm%20lighting%2C%20modern%20city%20background%2C%20soft%20romantic%20atmosphere%2C%20clean%20art%20style%2C%20professional%20character%20design&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    categories: ['romance', 'drama', 'comedy'],
    description: '表面上是完美职场女性的成德美，私下却是个狂热的偶像粉丝。当新来的美术馆馆长莱恩发现她的秘密后，两人的关系开始发生了微妙的变化。',
    rating: 9.2,
    views: 890000,
    status: '已完结',
    totalChapters: 86,
    latestChapter: '第86话（完）',
    updatedAt: '2026-04-15',
    isHot: false,
    isRecommended: true,
  },
  {
    id: 'comic-4',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%20of%20a%20protagonist%20surrounded%20by%20mysterious%20constellations%20and%20magical%20symbols%2C%20dramatic%20cosmic%20background%2C%20dark%20fantasy%20style%2C%20epic%20atmosphere%2C%20detailed%20illustration%20with%20golden%20accents&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    categories: ['fantasy', 'action', 'thriller'],
    description: '独学是唯一一个从头到尾读完了一部连载了3149话的网络小说的人。当小说世界变成现实的那一刻，他成了唯一知道这个世界结局的人。',
    rating: 9.6,
    views: 2450000,
    status: '连载中',
    totalChapters: 210,
    latestChapter: '第210话',
    updatedAt: '2026-08-04',
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-5',
    title: '反派小姐的男主人公',
    author: '李夏恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20fantasy%20manhwa%20cover%20of%20a%20villainess%20character%20with%20crown%20and%20elegant%20dark%20dress%2C%20rose%20garden%20background%2C%20dramatic%20lighting%2C%20beautiful%20detailed%20character%20art%2C%20romantic%20dark%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    categories: ['romance', 'fantasy', 'drama'],
    description: '一觉醒来变成了小说中注定死亡的恶毒女配。为了改变命运，她决定远离男主女主，过自己的小日子。可是为什么男主总是出现在她身边？',
    rating: 9.3,
    views: 1560000,
    status: '连载中',
    totalChapters: 98,
    latestChapter: '第98话',
    updatedAt: '2026-08-05',
    isHot: true,
    isRecommended: false,
  },
  {
    id: 'comic-6',
    title: '杀手食堂',
    author: '金宇彬',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%20of%20a%20mysterious%20chef%20holding%20knife%20in%20dark%20kitchen%2C%20noir%20style%2C%20dramatic%20shadow%20lighting%2C%20tense%20atmosphere%2C%20detailed%20character%20illustration%2C%20dark%20and%20moody%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    categories: ['action', 'thriller', 'drama'],
    description: '白天是普通餐厅的厨师，夜晚则是令人闻风丧胆的杀手。当他的双重身份被一个女记者发现后，两人之间展开了一场危险的猫鼠游戏。',
    rating: 9.1,
    views: 720000,
    status: '连载中',
    totalChapters: 67,
    latestChapter: '第67话',
    updatedAt: '2026-08-03',
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-7',
    title: '甜蜜暴击',
    author: '韩智敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%20of%20two%20high%20school%20students%20in%20uniform%20sharing%20earphones%2C%20cherry%20blossom%20background%2C%20warm%20spring%20lighting%2C%20youthful%20and%20sweet%20atmosphere%2C%20clean%20manga%20art%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    categories: ['romance', 'school', 'comedy'],
    description: '转学第一天就惹上了全校最不好惹的男生？学霸女主和校霸男主之间，从互看不顺眼到渐渐心动的甜蜜校园故事。',
    rating: 9.0,
    views: 980000,
    status: '已完结',
    totalChapters: 72,
    latestChapter: '第72话（完）',
    updatedAt: '2026-05-10',
    isHot: false,
    isRecommended: true,
  },
  {
    id: 'comic-8',
    title: '鬼怪的新娘',
    author: '朴秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20fantasy%20manhwa%20cover%20of%20a%20bride%20in%20white%20wedding%20dress%20with%20ghostly%20aura%2C%20dark%20forest%20background%2C%20mysterious%20moonlight%2C%20gothic%20romance%20style%2C%20beautiful%20but%20eerie%20atmosphere%2C%20detailed%20illustration&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    categories: ['horror', 'romance', 'fantasy'],
    description: '能看到鬼魂的女主角被选为鬼怪的新娘。千年鬼怪与能看到鬼的少女之间，一段跨越生死的奇妙姻缘就此展开。',
    rating: 9.4,
    views: 1350000,
    status: '连载中',
    totalChapters: 88,
    latestChapter: '第88话',
    updatedAt: '2026-08-04',
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-9',
    title: 'BL办公室',
    author: '尹善雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%20art%20of%20two%20handsome%20office%20men%20in%20suits%20facing%20each%20other%2C%20modern%20cityscape%20through%20window%2C%20soft%20romantic%20lighting%2C%20clean%20professional%20art%20style%2C%20mature%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    categories: ['bl', 'romance', 'drama'],
    description: '新入职的菜鸟和冷酷上司之间不可言说的办公室恋情。从误会到理解，从抗拒到沉沦，两个男人在职场中谱写的浪漫故事。',
    rating: 8.9,
    views: 650000,
    status: '连载中',
    totalChapters: 56,
    latestChapter: '第56话',
    updatedAt: '2026-08-02',
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-10',
    title: '古风奇谭',
    author: '赵敏英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%20of%20a%20warrior%20in%20traditional%20hanbok%20with%20sword%2C%20ancient%20Korean%20palace%20background%2C%20dramatic%20ink%20wash%20painting%20style%2C%20elegant%20composition%2C%20traditional%20Korean%20aesthetic&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    categories: ['historical', 'fantasy', 'action'],
    description: '以朝鲜王朝为背景的奇幻武侠故事。拥有神秘力量的武士，在乱世中守护着自己所珍视的一切。水墨画般的精美画风令人沉醉。',
    rating: 9.3,
    views: 780000,
    status: '连载中',
    totalChapters: 45,
    latestChapter: '第45话',
    updatedAt: '2026-08-05',
    isHot: false,
    isRecommended: true,
  },
  {
    id: 'comic-11',
    title: '暗夜追踪者',
    author: '崔明秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20manhwa%20cover%20of%20a%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20neon%20signs%20reflecting%20on%20wet%20ground%2C%20noir%20film%20style%2C%20dark%20moody%20atmosphere%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    categories: ['thriller', 'action'],
    description: '连环杀人案在首尔街头引发恐慌。刑警韩镇宇在追查真凶的过程中，发现案件背后隐藏着更大的阴谋。一场正义与邪恶的较量。',
    rating: 9.0,
    views: 560000,
    status: '连载中',
    totalChapters: 34,
    latestChapter: '第34话',
    updatedAt: '2026-08-01',
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-12',
    title: '搞笑一家人之漫画版',
    author: '金泰浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%20of%20a%20funny%20family%20with%20exaggerated%20expressions%2C%20colorful%20bright%20background%2C%20cartoonish%20humorous%20style%2C%20warm%20and%20playful%20atmosphere%2C%20detailed%20character%20designs%20with%20comedic%20poses&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    categories: ['comedy', 'drama'],
    description: '一个普通韩国家庭的爆笑日常。从奶奶的奇葩料理到儿子的中二病，每一话都能让你捧腹大笑，又能在笑声中感受家庭的温暖。',
    rating: 9.2,
    views: 420000,
    status: '已完结',
    totalChapters: 100,
    latestChapter: '第100话（完）',
    updatedAt: '2026-03-20',
    isHot: false,
    isRecommended: false,
  },
];

export const banners = [
  {
    id: 'banner-1',
    comicId: 'comic-2',
    title: '我独自升级 - 年度最佳完结韩漫',
    subtitle: '从最弱到最强，一场酣畅淋漓的逆袭之旅',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20action%20scene%20of%20a%20powerful%20warrior%20with%20dark%20shadow%20army%20in%20dungeon%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20cinematic%20wide%20composition%2C%20dark%20fantasy%20atmosphere%2C%20heroic%20pose%2C%20epic%20scale%2C%20professional%20illustration&width=1920&height=800&seq=banner-hero-01&orientation=landscape',
  },
  {
    id: 'banner-2',
    comicId: 'comic-4',
    title: '全知读者视角 - 热度飙升中',
    subtitle: '当小说变成现实，唯一知道结局的人能否拯救世界',
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20epic%20scene%20of%20a%20reader%20surrounded%20by%20magical%20constellations%20and%20floating%20text%2C%20cosmic%20background%2C%20dramatic%20golden%20lighting%2C%20cinematic%20wide%20shot%2C%20mysterious%20atmosphere&width=1920&height=800&seq=banner-hero-02&orientation=landscape',
  },
  {
    id: 'banner-3',
    comicId: 'comic-8',
    title: '鬼怪的新娘 - 新番推荐',
    subtitle: '千年鬼怪与能看见鬼的少女：跨越生死的奇妙姻缘',
    image: 'https://readdy.ai/api/search-image?query=Korean%20gothic%20romance%20fantasy%20manhwa%20scene%20of%20a%20bride%20and%20ghostly%20groom%20in%20moonlit%20ancient%20forest%2C%20ethereal%20atmosphere%2C%20soft%20moonlight%2C%20romantic%20and%20mysterious%20wide%20composition%2C%20beautiful%20illustration&width=1920&height=800&seq=banner-hero-03&orientation=landscape',
  },
];